module.exports = __webpack_public_path__ + "img/KSC05697.c21567a0.jpg";